/* eslint react/no-direct-mutation-state: "off", 'no-redeclare': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Col, FormGroup, Label, Form } from "reactstrap";
import { connect } from "react-redux";
import { GetWorkOrderBuildings } from  '../../../../action/workorderAction';
import { Icon } from 'semantic-ui-react';
import {MdSave} from 'react-icons/md';

const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class AddEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsError: false,
            IsDuplicateError: false,
            error: {
                name: false,
                building: false
            }
        };
    }

    componentWillMount(){
        this.props.GetWorkOrderBuildings();
    }

    SaveNewEquipment(){
        this.state.error.name = false;
        var l_EquipmentName = this.refs.equipment_name_input.value;
        if(this.props.IsEdit)
        {
            if(l_EquipmentName != "")
            {
                if(this.props.getList.WorkorderEquipments.filter(x => x.name == l_EquipmentName).length == 0)
                {
                    this.state.error.name = false;
                    var LineItem = {
                        "Id": this.props.details.id,
                        "Name": l_EquipmentName,
                        "SiteId": this.props.details.siteId,
                        "IsDeleted": false
                    }
        
                    let Equipments = [];
                    Equipments.push(LineItem);
                    var callSaveMethod = this.props.onSave;
                    callSaveMethod(Equipments);
                }
                else
                {
                    this.state.error.name = true;
                    this.setState({IsDuplicateError : true});
                }
            }
            else{
                this.setState({IsError : true});
                this.state.error.name = true;
            }
        }
        else
        {

        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;

        if(selectedSiteId > 0 && l_EquipmentName != "")
        {
            if(this.props.getList.WorkorderEquipments.filter(x => x.name == l_EquipmentName).length == 0)
            {
                this.state.error.name = false;
                this.state.error.building = false;
            var LineItem = {
                "Name": l_EquipmentName,
                "SiteId": selectedSiteId
            }

            let Equipments = [];
            Equipments.push(LineItem);
            var callSaveMethod = this.props.onSave;
            callSaveMethod(Equipments);
        }
        else
        {
            this.state.error.name = true;
            this.setState({IsDuplicateError : true});
        }
        }
        else{
            if(l_EquipmentName == "")
                this.state.error.name = true;
            if(selectedSiteId == 0)
                this.state.error.building = true;
            this.setState({IsError : true});
        }
    }

}

    CancelEquipment()
    {
        var CancelCall = this.props.onCancel;
        CancelCall();
    }

    render(){
        var Error_Msg;
        var BuildingList;
        var Buildingname;
        // let label = this.props.getLabels;
        var isEdit = this.props.IsEdit; 
        var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label> 

        if(this.state.IsError || this.state.IsDuplicateError){
            Error_Msg = <p style={ErrorPadding}>
                <Icon name='exclamation triangle' style={ErrorSign} /><b>Please correct all errors before continuing.</b>
            </p>
        }

        if(this.props.getList.WorkorderBuildings != undefined)
            BuildingList = this.props.getList.WorkorderBuildings.filter(x => x.isDeleted == false ).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()))

        var buildings_in_Select_input = BuildingList.map(el => (
                <option id={el.id}>{el.name}</option>
            ));

        if(this.props.IsEdit)
        {
            if(BuildingList.filter(x => x.id == this.props.details.siteId)[0] != undefined)
                Buildingname = BuildingList.filter(x => x.id == this.props.details.siteId)[0].name;
        }

        return(
            <div className="main_container" style={{'max-width':'100%','overflow-x':'auto'}}>
                {Error_Msg}
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <Label className='workordermainheaderlbl'>{isEdit ? "Edit Non-discovered Equipment" : "Add Non-discovered Equipment"}</Label>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <div className="workorderbtn-cancel" onClick={() => { this.CancelEquipment() }} style={{ 'float': 'right', 'margin-left': '6px' }}>CANCEL</div>
                            <div className="workorderbtn-save" onClick={() => { this.SaveNewEquipment() }} style={{ 'float': 'right' }}><MdSave style={{ width: '15px', height: '15px', 'margin-right': '3px' }} />SAVE</div>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 12 }}>
                            <hr style={{ backgroundColor: '#666666', border: 'none', height: '1px' }} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label className='workordermainheaderlbl'>Equipment Details</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label className={(this.state.error.name) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>Name</Label><br />
                            <input type="text" ref='equipment_name_input' className={(this.state.error.name) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={this.props.IsEdit ? this.props.details.name : ""} maxLength="50" />
                            <span hidden={!this.state.error.name}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>{this.state.IsDuplicateError ? "Duplicate Building Name" : "An entry is required"}</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4 }}>
                            <Label className={(this.state.error.building) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>Building(s)</Label><br />
                            {
                                this.props.IsEdit == true ? <Label className="workorderheaderlbl">{Buildingname}</Label> :
                                <p>
                                <select ref='buildings_in_Select_input' className={(this.state.error.building) ?"errorhighlight minimal workorderedit-dropdown" :"minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.LoadBuildingFloors} >
                                    {buildings_in_Select_input}
                                </select>
                                <span hidden={!this.state.error.building}>{selecterrortext}</span>
                                </p>
                            }
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderlbl CreatePMlbl_margin'>Family Type</Label><br />
                            <Label className="workorderheaderlbl">Other</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderlbl CreatePMlbl_margin'>Discovered</Label><br />
                            <Label className="workorderheaderlbl">No</Label>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getList: state.WorkorderRootReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEquipment);